import { render, staticRenderFns } from "./BulkImportDialog.vue?vue&type=template&id=684694e5&scoped=true"
import script from "./BulkImportDialog.vue?vue&type=script&lang=js"
export * from "./BulkImportDialog.vue?vue&type=script&lang=js"
import style0 from "./BulkImportDialog.vue?vue&type=style&index=0&id=684694e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684694e5",
  null
  
)

export default component.exports